import classnames from 'classnames';
import * as TMenu from 'components/menu';
import listSubmenu from 'constants/menu-config';
import { CheckPermission } from 'modules/login/CheckPermission';
import React from 'react';
import cookie from 'react-cookie';
import { connect } from 'react-redux';
import { Link, browserHistory } from 'react-router';
let homeIcon = require('assets/images/home-mn.png');
let tcdIcon = require('assets/images/tcd-mn.png');
let xldIcon = require('assets/images/xld-mn.png');
let gdqIcon = require('assets/images/gqd-mn.png');
let ttIcon = require('assets/images/tt-mn.png');
let thbcIcon = require('assets/images/thbc-mn.png');
let tdgsIcon = require('assets/images/tdgs-mn.png');
let qthtIcon = require('assets/images/qtht-mn.png');
let folderIcon = require('assets/fonts/icon/folder.svg');
let paperDocument = require('assets/fonts/icon/paper-document.svg');
let statistical = require('assets/fonts/icon/growth.svg');
let baoCaoThamNhungIcon = require('assets/images/bao-cao-tham-nhung.png');

class MultipleLeverMenu extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      displaySystemMenu: false,
      displaySystemMenuDanhMuc: false,
      displaySystemMenuDonVi: false,
      displaySystemMenuNguoiDung: false,
      displaySystemMenuCauHinh: false,
      tongSoDonXLD: 0,
      tongSoDonGQD: 0,
      tongSoDonDinhKy: 0,
      tongSoDonDotXuat: 0,
      tongSoDonYeuCau: 0,
      tongSoDonTDTH: 0,
      isMenuAdmin: false
    }
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillMount() {
    this.checkPermissionMenu();
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps) {
    // this.checkDonVi();
    if (nextProps.notifyTongXLD) {
      this.setState({ tongSoDonXLD: nextProps.notifyTongXLD.tongSoDon });
    }
    if (nextProps.notifyTongDonDK) {
      this.setState({ tongSoDonDinhKy: nextProps.notifyTongDonDK.tongSoDon });
    }
    if (nextProps.notifyTongDonDX) {
      this.setState({ tongSoDonDotXuat: nextProps.notifyTongDonDX.tongSoDon });
    }
    if (nextProps.notifyTongDonYC) {
      this.setState({ tongSoDonYeuCau: nextProps.notifyTongDonYC.tongSoDon });
    }
    if (nextProps.notifyTongGQD) {
      this.setState({ tongSoDonGQD: nextProps.notifyTongGQD.tongSoDon });
    }
    if (nextProps.notifyTongDonTDTH) {
      this.setState({ tongSoDonTDTH: nextProps.notifyTongDonTDTH.tongSoDon });
    }
  }

  // checkDonVi() {
  //   let ThamSo = localStorage.getItem('thamSo') ? JSON.parse(localStorage.getItem('thamSo')) : [];
  //   let thanhTraThanhPhoId = ThamSo.filter(item => item.ten == 'CQQL_THANH_TRA_THANH_PHO');
  //   if (this.refs.menuBar) {
  //     this.setState({thanhTraThanhPhoId: thanhTraThanhPhoId.length ? thanhTraThanhPhoId[0].giaTri : ''});
  //   }
  // }

  componentDidMount() {
    const items = document.getElementsByClassName('menu-list')[0].children;
    let isMenuAdmin = false;
    if (items.length > 6) {
      isMenuAdmin = true;
    } else {
      isMenuAdmin = false;
    }
    this.setState({ isMenuAdmin });

    // this.checkDonVi();
    if (typeof cookie.load('accessToken') === 'undefined') {
      browserHistory.push('/dang-nhap');
    } else {
      if (this.props.notifyTongXLD) {
        this.setState({ tongSoDonXLD: this.props.notifyTongXLD.tongSoDon });
      }
      if (this.props.notifyTongDonDK) {
        this.setState({ tongSoDonDinhKy: this.props.notifyTongDonDK.tongSoDon });
      }
      if (this.props.notifyTongDonDX) {
        this.setState({ tongSoDonDotXuat: this.props.notifyTongDonDX.tongSoDon });
      }
      if (this.props.notifyTongDonYC) {
        this.setState({ tongSoDonYeuCau: this.props.notifyTongDonYC.tongSoDon });
      }
      if (this.props.notifyTongGQD) {
        this.setState({ tongSoDonGQD: this.props.notifyTongGQD.tongSoDon });
      }
      if (this.props.notifyTongDonTDTH) {
        this.setState({ tongSoDonTDTH: this.props.notifyTongDonTDTH.tongSoDon });
      }
    }
  }

  checkPermissionMenu() {
    listSubmenu.quanLyDanhMuc.map((item, i) => {
      if (CheckPermission(item.key)) {
        this.setState({ displaySystemMenuDanhMuc: true, displaySystemMenu: true });
      }
    });
    listSubmenu.quanLyDonVi.map((item, i) => {
      if (CheckPermission(item.key)) {
        this.setState({ displaySystemMenuDonVi: true, displaySystemMenu: true });
      }
    });
    listSubmenu.quanLyNguoiDung.map((item, i) => {
      if (CheckPermission(item.key)) {
        this.setState({ displaySystemMenuNguoiDung: true, displaySystemMenu: true });
      }
    });
    listSubmenu.cauHinhHeThong.map((item, i) => {
      if (CheckPermission(item.key)) {
        this.setState({ displaySystemMenuCauHinh: true, displaySystemMenu: true });
      }
    });
  }

  onMessage(msg) {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    let idList = msg.listIdUser.split(';');
    if (idList.indexOf(String(userInfo.id)) != -1 && msg.soLuong != 'KHONG') {
      switch (msg.type) {
        // case 'TB_DON_XL':
        //   if (msg.soLuong == 'TANG') {
        //     this.state.tongSoDonXLD += 1;
        //   } else {
        //     this.state.tongSoDonXLD -= 1;
        //   }
        //   this.props.dispatch({
        //     type: 'UPDATE_TONGDON',
        //     key: 'notifyTongXLD',
        //     value: this.state.tongSoDonXLD
        //   });
        // break;
        case 'TB_DON_TCD_LANH_DAO':
          if (msg.soLuong == 'TANG') {
            this.state.tongSoDonYeuCau += 1;
          } else {
            this.state.tongSoDonYeuCau -= 1;
          }
          this.props.dispatch({
            type: 'UPDATE_TONGDON',
            key: 'notifyTongDonYC',
            value: this.state.tongSoDonYeuCau
          });
          break;
        case 'TB_DON_TCD_DINH_KY':
          if (msg.soLuong == 'TANG') {
            this.state.tongSoDonDinhKy += 1;
          } else {
            this.state.tongSoDonDinhKy -= 1;
          }
          this.props.dispatch({
            type: 'UPDATE_TONGDON',
            key: 'notifyTongDonDK',
            value: this.state.tongSoDonDinhKy
          });
          break;
        case 'TB_DON_TCD_DOT_XUAT':
          if (msg.soLuong == 'TANG') {
            this.state.tongSoDonDotXuat += 1;
          } else {
            this.state.tongSoDonDotXuat -= 1;
          }
          this.props.dispatch({
            type: 'UPDATE_TONGDON',
            key: 'notifyTongDonDX',
            value: this.state.tongSoDonDotXuat
          });
          break;
        case 'TB_DON_GQ':
          if (msg.soLuong == 'TANG') {
            this.state.tongSoDonGQD += 1;
          } else {
            this.state.tongSoDonGQD -= 1;
          }
          this.props.dispatch({
            type: 'UPDATE_TONGDON',
            key: 'notifyTongGQD',
            value: this.state.tongSoDonGQD
          });
          break;
        case 'TB_DON_TDTH':
          if (msg.soLuong == 'TANG') {
            this.state.tongSoDonTDTH += 1;
          } else {
            this.state.tongSoDonTDTH -= 1;
          }
          this.props.dispatch({
            type: 'UPDATE_TONGDON',
            key: 'notifyTongDonTDTH',
            value: this.state.tongSoDonTDTH
          });
          break;
      }
      if (this.refs.menuBar) {
        this.setState({ ...this.state });
      }
    }
  }

  render() {
    let tcdNofifyCount = this.state.tongSoDonYeuCau + this.state.tongSoDonDinhKy + this.state.tongSoDonDotXuat;
    const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    const TTTW = 19;
    return (
      <nav className="menu-top" ref="menuBar">
        {/*<Socket url={API_URL+'/ws'} topics={[`/queue/notify`]} onMessage={this.onMessage.bind(this)} ref={(client) => { this.clientRef = client }} />*/}
        <TMenu.Menu>
          {
            userInfo.capCoQuanQuanLyId !== TTTW && userInfo.loaiVaiTroMacDinh !== 'NHAP_LIEU_DON_CU' &&
            <li className={`menu-items ${this.props.routerName == 'home' ? 'is-active' : ''}`}>
              <Link to="/" className="item-link" id="menuTrangChu">
                <span className="wrap-img-mn"><img src={homeIcon} alt="trang-chu" /></span>
                Trang chủ
              </Link>
            </li>
          }
          {/* {
            CheckPermission('SOTIEPCONGDAN_LIETKE') &&
            <li className={`menu-items menu-haschildren ${this.props.routerName == 'tiepcongdan' ? 'is-active' : ''}`}>
              <Link className="item-link" id="menuTiepCongDan">
                <span className="wrap-img-mn">
                  <img src={tcdIcon} alt="tiep-cong-dan" />
                  {
                    tcdNofifyCount > 0 ? (
                      tcdNofifyCount > 99 ? (
                        <span className='menu-notification mid'>99<sup>+</sup></span>
                      ) : (
                        <span className='menu-notification mid'>{tcdNofifyCount}</span>
                      )
                    ) : null
                  }
                </span>
                Tiếp công dân
              </Link>
              <ul className="sub-menu">
                <li className="menu-items  is-active">
                  <Link to="/tiep-cong-dan" id="menuTiepCongDanTX" className="item-link">Sổ tiếp công dân thường xuyên</Link>
                </li>
                <li className="menu-items sub-menu-haschildren">
                  <Link className="item-link" id="menuSoTiepCongDanLD">Sổ tiếp công dân của lãnh đạo</Link>
                  <ul className="sub-menu">
                    <li className="menu-items sub-menu-haschildren"><Link className="item-link" id="menuDinhKy">Định kỳ</Link>
                      <ul className="sub-menu" style={{ width: '250px' }}>
                        <li className="menu-items">
                          <Link to="/tiep-cong-dan/danh-sach-yeu-cau" id="menuDanhSachYeuCau" className="item-link">
                            {this.state.tongSoDonYeuCau > 0 ? (
                              this.state.tongSoDonYeuCau > 99 ? (
                                <span className='menu-notification child'>99<sup>+</sup></span>
                              ) : (
                                <span className='menu-notification child'>{this.state.tongSoDonYeuCau}</span>
                              )
                            ) : null
                            }
                            Danh sách đăng ký gặp lãnh đạo
                          </Link>
                        </li>
                        <li className="menu-items">
                          <Link to="/tiep-cong-dan/dinh-ky" id="menuSoTiepDinhKy" className="item-link">
                            {this.state.tongSoDonDinhKy > 0 ? (
                              this.state.tongSoDonDinhKy > 99 ? (
                                <span className='menu-notification child'>99<sup>+</sup></span>
                              ) : (
                                <span className='menu-notification child'>{this.state.tongSoDonDinhKy}</span>
                              )
                            ) : null
                            }
                            Sổ tiếp định kỳ của lãnh đạo
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <li className="menu-items">
                      <Link to="/tiep-cong-dan/dot-xuat" id="menuTiepCongDanDX" className="item-link">
                        {this.state.tongSoDonDotXuat > 0 ? (
                          this.state.tongSoDonDotXuat > 99 ? (
                            <span className='menu-notification child'>99<sup>+</sup></span>
                          ) : (
                            <span className='menu-notification child'>{this.state.tongSoDonDotXuat}</span>
                          )
                        ) : null
                        }
                        Đột xuất
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          }
          {
            CheckPermission('XULYDON_LIETKE') &&
            <li className={`menu-items ${this.props.routerName == 'xulydon' ? 'is-active' : ''}`}>
              <Link to="/xu-ly-don" className="item-link" id="menuXuLyDon">
                <span className="wrap-img-mn">
                  <span className='wrap-notification'>
                    <img src={xldIcon} alt="xu-ly-don" />
                    {
                      this.state.tongSoDonXLD > 0 ? (
                        this.state.tongSoDonXLD > 99 ? (
                          <span className='menu-notification'>99<sup>+</sup></span>
                        ) : (
                          <span className='menu-notification'>{this.state.tongSoDonXLD}</span>
                        )
                      ) : null
                    }
                  </span>
                </span>
                Xử lý đơn
              </Link>
            </li>
          }
          {
            CheckPermission('GIAIQUYETDON_LIETKE') &&
            <li className={`menu-items ${this.props.routerName == 'giaiquyet' ? 'is-active' : ''}`}>
              <Link className="item-link" to='/giai-quyet-don' id="menuGiaiQuyetDon">
                <span className="wrap-img-mn">
                  <span className='wrap-notification'>
                    <img src={gdqIcon} alt="giai-quyet-don" />
                    {
                      this.state.tongSoDonGQD > 0 ? (
                        this.state.tongSoDonGQD > 99 ? (
                          <span className='menu-notification'>99<sup>+</sup></span>
                        ) : (
                          <span className='menu-notification'>{this.state.tongSoDonGQD}</span>
                        )
                      ) : null
                    }
                  </span>
                </span>
                Giải quyết đơn
              </Link>
            </li>
          }
          {
            CheckPermission('DONDAGIAIQUYET_LIETKE') &&
            <li className={`menu-items ${this.props.routerName == 'dagiaiquyet' ? 'is-active' : ''}`}>
              <Link className="item-link" to='/don-da-giai-quyet' id="menuDaGiaiQuyet">
                <span className="wrap-img-mn">
                  <img src={gdqIcon} alt="giai-quyet-don" />
                </span>
                Đơn đã giải quyết
              </Link>
            </li>
          } */}
          {
            CheckPermission('THANHTRA_LIETKE') &&
            <li className={`menu-items menu-haschildren ${(this.props.routerName.indexOf('thanhtra') != -1) ? 'is-active' : ''}`}>
              <Link className="item-link" id="menuThanhTra">
                <span className="wrap-img-mn"><img src={ttIcon} alt="thanh-tra" /></span>
                Thanh tra
              </Link>
              <ul className="sub-menu ">
                <li className={classnames('menu-items', { 'sub-menu-haschildren': this.props.thanhTraThanhPhoId === userInfo.donViId })}>
                  {
                    this.props.thanhTraThanhPhoId === userInfo.donViId ?
                      <span className="item-link">Danh sách kế hoạch thanh tra</span> :
                      <Link to='/thanh-tra' id="menuDanhSachKeHoachTT" className="item-link">Danh sách kế hoạch thanh tra</Link>
                  }
                  {
                    this.props.thanhTraThanhPhoId === userInfo.donViId &&
                    <ul className="sub-menu sub-menu-thongke">
                      <TMenu.MenuItem path='/thanh-tra' id='menuKHTT_0' name='Danh sách KHTT tại Thanh tra tỉnh' key={0} />
                      <TMenu.MenuItem path='/thanh-tra/danh-sach-tong-hop-khtt-cua-cac-don-vi' id='menuKHTT_1' name='Danh sách KHTT của các đơn vị' key={1} />
                    </ul>
                  }
                </li>
                <li className="menu-items">
                  <Link to='/thanh-tra-da-phe-duyet' id="menuDanhSachKeHoachTTDPD" className="item-link">Danh sách kế hoạch đã phê duyệt</Link>
                </li>
                <li className={classnames('menu-items', { 'sub-menu-haschildren': this.props.thanhTraThanhPhoId === userInfo.donViId })}>
                  {
                    this.props.thanhTraThanhPhoId === userInfo.donViId ?
                      <span className="item-link">Danh mục cuộc TT, KT</span> :
                      <Link to='/thanh-tra/danh-sach-cuoc-thanh-tra' id="menuDanhSachCuocTT" className="item-link">Danh mục cuộc TT, KT</Link>
                  }
                  {
                    this.props.thanhTraThanhPhoId === userInfo.donViId &&
                    <ul className="sub-menu sub-menu-thongke">
                      <TMenu.MenuItem path='/thanh-tra/danh-sach-cuoc-thanh-tra' id='menuCTT_0' name='Danh mục cuộc TT, KT tại Thanh tra tỉnh' key={0} />
                      <TMenu.MenuItem path='/thanh-tra/danh-muc-tong-hop-thanh-tra-cua-cac-don-vi' id='menuCTT_1' name='Danh mục cuộc TT, KT của các đơn vị' key={1} />
                    </ul>
                  }
                </li>
                {
                  CheckPermission('CUOCTHANHTRATRUNG_XEM') &&
                  <li className="menu-items"><Link to='/thanh-tra/danh-muc-cuoc-thanh-tra-trung' id="menuDanhSachDoiTuongTT" className="item-link">Danh mục cuộc thanh tra trùng</Link></li>
                }
                {
                  userInfo.donViId === this.props.thanhTraThanhPhoId &&
                  <li className="menu-items"><Link to='/thanh-tra/danh-sach-lich-su-ttt' id="menuDanhSachDoiTuongTT" className="item-link">Danh sách lịch sử xử lý trùng</Link></li>
                }
              </ul>
            </li>
          }
          {
            (CheckPermission('THEODOIGIAMSAT_LIETKE') || CheckPermission('THEO_DOI_THUC_HIEN_LIETKE') || CheckPermission('THEODOITHUCHIENSAUGIAIQUYET_LIETKE')) &&
            <li className={`menu-items menu-haschildren ${this.props.routerName == 'theodoi' ? 'is-active' : ''}`}>
              <Link className="item-link" id="menuTheoDoiGiamSat">
                <span className="wrap-img-mn"><img src={tdgsIcon} alt="theo-doi" />
                  {
                    this.state.tongSoDonTDTH > 0 ? (
                      this.state.tongSoDonTDTH > 99 ? (
                        <span className='menu-notification mid'>99<sup>+</sup></span>
                      ) : (
                        <span className='menu-notification mid'>{this.state.tongSoDonTDTH}</span>
                      )
                    ) : null
                  }
                </span>
                Theo dõi
              </Link>
              <ul className="sub-menu " style={{ width: '245px' }}>
                {
                  CheckPermission('THEODOIGIAMSAT_LIETKE') &&
                  <li className="menu-items"><Link className="item-link" to='/theo-doi-giam-sat/tinh-hinh-xld-tai-don-vi' id="menuTD_GS">Kiểm tra theo dõi đôn đốc</Link></li>
                }
                {
                  CheckPermission('THEO_DOI_THUC_HIEN_LIETKE') &&
                  <li className="menu-items"><Link className="item-link" to='/danh-sach-theo-doi-thuc-hien' id="menuTD_TH">Theo dõi thực hiện sau thanh tra</Link></li>
                }
                {
                  CheckPermission('THEODOITHUCHIENSAUGIAIQUYET_LIETKE') &&
                  <li className="menu-items"><Link className="item-link" to='/theo-doi-thuc-hien-giai-quyet-don' id="menuTD_TH_GQD">
                    {this.state.tongSoDonTDTH > 0 ? (
                      this.state.tongSoDonTDTH > 99 ? (
                        <span className='menu-notification child'>99<sup>+</sup></span>
                      ) : (
                        <span className='menu-notification child'>{this.state.tongSoDonTDTH}</span>
                      )
                    ) : null
                    }
                    Theo dõi thực hiện giải quyết đơn</Link>
                  </li>
                }
                {/* <li className="menu-items"><Link className="item-link" to='/theo-doi-giam-sat/thong-ke-giam-sat-nhap-don-cu' id="menuBCDinhKy">Thống kê giám sát nhập đơn cũ</Link></li> */}
              </ul>
            </li>
          }
          <li className={`menu-items menu-haschildren ${(this.props.routerName.indexOf('quanlyhoso') != -1) ? 'is-active' : ''}`}>
            <Link className="item-link" id="menuQuanLyHoSo">
              <span className="wrap-img-mn"><img src={folderIcon} alt="quan-ly-ho-so" /></span>
              Quản lý hồ sơ
            </Link>
            <ul className={classnames('sub-menu', { '': this.state.isMenuAdmin, 'menu-pull-right': !this.state.isMenuAdmin })}>
              <li className="menu-items"><Link className="item-link" to="/quan-ly-ho-so/danh-sach-ho-so" id="menuDSHS">Danh sách hồ sơ</Link></li>
              <li className="menu-items"><Link className="item-link" to='/quan-ly-ho-so/danh-muc-nhom-ho-so' id="menuDMNHS">Danh mục nhóm hồ sơ</Link></li>
            </ul>
          </li>
          {
            CheckPermission('TONGHOPBAOCAO_LIETKE') &&
            <li className={`menu-items menu-haschildren ${(this.props.routerName.indexOf('thongkebaocao') != -1) ? 'is-active' : ''}`}>
              <Link className="item-link" id="menuTongHopBC">
                <span className="wrap-img-mn"><img src={thbcIcon} alt="tongHopBaoCao" /></span>
                Tổng hợp báo cáo
              </Link>
              <ul className="sub-menu ">
                <li className="menu-items sub-menu-haschildren"><Link className="item-link" id="menuBCThanhTra">Báo cáo thanh tra</Link>
                  <ul className="sub-menu sub-menu-thongke">
                    {
                      listSubmenu.thongKeBaoCaoThanhTra.map((menuItem, index) => {
                        if (CheckPermission(menuItem.key)) {
                          return (
                            <TMenu.MenuItem path={menuItem.path} id={`menuBCThanhTra${index}`} name={menuItem.name} key={index} />
                          )
                        }
                      })
                    }
                  </ul>
                </li>
                <li className="menu-items sub-menu-haschildren"><Link className="item-link" id="menuBCThanhTra">Báo cáo kiểm tra</Link>
                  <ul className="sub-menu sub-menu-thongke">
                    {
                      listSubmenu.baoCaoKiemTra.map((menuItem, index) => {
                        if (CheckPermission(menuItem.key)) {
                          return (
                            <TMenu.MenuItem path={menuItem.path} id={`menuBCThanhTra${index}`} name={menuItem.name} key={index} />
                          )
                        }
                      })
                    }
                  </ul>
                </li>
              </ul>
            </li>
          }
          {
            CheckPermission('DONCU_LIETKE') &&
            <li className={classnames('menu-items', { 'is-active': this.props.routerName === 'xulydoncu' })}>
              <Link to="/xu-ly-don-cu" className="item-link" id="menuXuLyDon">
                <span className="wrap-img-mn">
                  <span className='wrap-notification'>
                    <img src={xldIcon} alt="xu-ly-don-cu" />
                  </span>
                </span>
                Nhập liệu đơn cũ
              </Link>
            </li>
          }
          <li className={`menu-items menu-haschildren ${(this.props.routerName.indexOf('vanban') != -1) ? 'is-active' : ''}`}>
            <Link className="item-link" id="menuLyVanBan">
              <span className="wrap-img-mn"><img src={paperDocument} alt="quan-ly-van-ban" /></span>
              Quản lý văn bản
            </Link>
            <ul className={classnames('sub-menu', { '': this.state.isMenuAdmin, 'menu-pull-right': !this.state.isMenuAdmin })}>
              <li className="menu-items"><Link className="item-link" to='/quan-ly-van-ban/danh-sach-van-ban' id="menuQLDMVB">Quản lý danh mục văn bản</Link></li>
              <li className="menu-items"><Link className="item-link" to='/quan-ly-van-ban/the-loai-van-ban' id="menuQLVB">Thể loại văn bản</Link></li>
              <li className="menu-items"><Link className="item-link" to='/quan-ly-van-ban/linh-vuc-van-ban' id="menuLVVB">Lĩnh vực văn bản</Link></li>
              <li className="menu-items"><Link className="item-link" to='/quan-ly-van-ban/co-quan-ban-hanh-van-ban' id="menuCQBHVB">Cơ quan ban hành văn bản</Link></li>
            </ul>
          </li>
          {/*
          <li className="menu-items">
            <Link className="item-link">
              <span className="wrap-img-mn"><img src={helpIcon} /></span>
              Trợ giúp
            </Link>
          </li>*/}
          <li className={`menu-items ${(this.props.routerName.indexOf('thongKe') != -1) ? 'is-active' : ''}`}>
            <Link to="/thong-ke" className="item-link" id="menuThongKe">
              <span className="wrap-img-mn"><img src={statistical} alt="thong-ke" /></span>
              Thống kê
            </Link>
          </li>
          <li className={`menu-items ${this.props.routerName == 'baocaothamnhung' ? 'is-active' : ''}`}>
            <Link to="/bao-cao-tham-nhung" className="item-link" id="menuTrangChu">
              <span className="wrap-img-mn"><img src={baoCaoThamNhungIcon} alt="bao-cao-tham-nhung" /></span>
              Báo cáo tham nhũng
            </Link>
          </li>
          {
            this.state.displaySystemMenu &&
            <li className={`menu-items menu-haschildren ${(this.props.routerName.indexOf('danhmuc') != -1) ? 'is-active' : ''}`}>
              <Link className="item-link" id="menuQuanTriHeThong">
                <span className="wrap-img-mn"><img src={qthtIcon} alt="quan-tri-ht" /></span>
                Quản trị hệ thống
              </Link>
              <ul className={classnames('sub-menu', { '': this.state.isMenuAdmin, 'menu-pull-right': !this.state.isMenuAdmin })}>
                {
                  this.state.displaySystemMenuDanhMuc &&
                  <li className="menu-items sub-menu-haschildren"><Link className="item-link" id="menuQuanLyDanhMuc">Quản lý danh mục</Link>
                    <ul className="sub-menu">
                      {
                        listSubmenu.quanLyDanhMuc.map((menuItem, index) => {
                          if (CheckPermission(menuItem.key)) {
                            return (
                              <TMenu.MenuItem path={menuItem.path} id={`menuQuanLyDanhMuc${index}`} name={menuItem.name} key={index} />
                            )
                          }
                        })
                      }
                    </ul>
                  </li>
                }
                {
                  this.state.displaySystemMenuDonVi &&
                  <li className="menu-items sub-menu-haschildren"><Link className="item-link" id="menuQuanLyDonVi">Quản lý đơn vị</Link>
                    <ul className="sub-menu">
                      {
                        listSubmenu.quanLyDonVi.map((menuItem, index) => {
                          if (CheckPermission(menuItem.key)) {
                            return (
                              <TMenu.MenuItem path={menuItem.path} id={`menuQuanLyDonVi${index}`} name={menuItem.name} key={index} />
                            )
                          }
                        })
                      }
                    </ul>
                  </li>
                }
                {
                  this.state.displaySystemMenuNguoiDung &&
                  <li className="menu-items sub-menu-haschildren"><Link className="item-link" id="menuQuanLyNguoiDung">Quản lý người dùng</Link>
                    <ul className="sub-menu">
                      {
                        listSubmenu.quanLyNguoiDung.map((menuItem, index) => {
                          if (CheckPermission(menuItem.key)) {
                            return (
                              <TMenu.MenuItem path={menuItem.path} id={`menuQuanLyNguoiDung${index}`} name={menuItem.name} key={index} />
                            )
                          }
                        })
                      }
                    </ul>
                  </li>
                }
                {
                  this.state.displaySystemMenuCauHinh &&
                  <li className="menu-items sub-menu-haschildren"><Link className="item-link" id="menuCauHinhHeThong">Cấu hình hệ thống</Link>
                    <ul className="sub-menu">
                      {
                        listSubmenu.cauHinhHeThong.map((menuItem, index) => {
                          if (CheckPermission(menuItem.key)) {
                            return (
                              <TMenu.MenuItem path={menuItem.path} id={`menuCauHinhHeThong${index}`} name={menuItem.name} key={index} />
                            )
                          }
                        })
                      }
                    </ul>
                  </li>
                }
                {
                  CheckPermission('THAYDOICANBO_LIETKE') &&
                  <li className="menu-items"><Link to='/quan-ly-danh-muc/cap-nhat-nguoi-dung' className="item-link" id="menuCapNhatNguoiDung">Cập nhật người dùng</Link></li>
                }
                {
                  CheckPermission('THAYDOICANBOXULYDON_LIETKE') &&
                  <li className="menu-items"><Link to='/quan-ly-danh-muc/danh-sach-don-theo-cong-chuc' className="item-link" id="menuCapNhatNguoiDung">Thay đổi người dùng xử lý</Link></li>
                }
              </ul>
            </li>
          }
        </TMenu.Menu>
      </nav>
    );
  }
}

function bindStateToProps(state) {
  return {
    notifyTongXLD: state.duLieuHeThong.notifyTongXLD,
    notifyTongDonDK: state.duLieuHeThong.notifyTongDonDK,
    notifyTongGQD: state.duLieuHeThong.notifyTongGQD,
    notifyTongDonDX: state.duLieuHeThong.notifyTongDonDX,
    notifyTongDonYC: state.duLieuHeThong.notifyTongDonYC,
    notifyTongDonTDTH: state.duLieuHeThong.notifyTongDonTDTH
  };
}

export default connect(bindStateToProps)(MultipleLeverMenu);



// WEBPACK FOOTER //
// ./src/components/layout/partials/MultipleLeverMenu.jsx